export { EdpContractConsumptionsComponent } from "./edp-widget-consumptions.component";
export { EdpContractConsumptionsGasComponent } from "./edp-widget-consumptions-gas/edp-widget-consumptions-gas.component";
export { EdpWidgetConsumptionsSupportComponent } from "./edp-widget-consumptions-support/edp-widget-consumptions-support.component";
